<template>
  <div class="home_page">
    <Header></Header>
    <div class="content">
      <div class="stepClass" style="margin-top:120px">
        <el-steps :active="active" align-center finish-status="success">
          <!-- <el-step title="报名须知"></el-step> -->
          <el-step title="注册"></el-step>
          <el-step title="图片上传"></el-step>
          <el-step title="开票信息"></el-step>
          <el-step title="审核"></el-step>
        </el-steps>
      </div>
      <!-- 是否提交start -->
      <!-- <el-dialog title="提示" :visible.sync="dialogVisible6" width="30%">
        <span>是否提交报名?</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible6 = false">取 消</el-button>
          <el-button type="primary" @click="confirmCommitFun">确 定</el-button>
        </span>
      </el-dialog> -->
      <!-- 是否提交end -->
      <!-- <el-dialog class="agreement-class" :visible="agreementShow" @close="agreementShow = false" :show-close="false">
        <div class="flex flex-column flex-algin-center " style="margin-top:0px"> -->
          <!-- v-if="active == 0" -->
          <!-- <div>
            <div class="welfare_publicity2">
              <div class="welfare_publicity2_cancel" @click="agreementShow = !agreementShow">x</div>
              <div class="title">用户服务协议</div>
              <div class="rich_box" v-html="htmeRich2"></div>

            </div>
          </div>
        </div>
      </el-dialog> -->
      <!-- 用户隐私协议stat -->
      <!-- <el-dialog class="agreement-class" :visible="agreementShow2" @close="agreementShow = false" :show-close="false">
        <div class="flex flex-column flex-algin-center " style="margin-top:0px"> -->
          <!-- v-if="active == 0" -->
          <!-- <div>
            <div class="welfare_publicity2">
              <div class="welfare_publicity2_cancel" @click="agreementShow2 = !agreementShow2">x</div>
              <div class="title">用户隐私协议</div>
              <div class="rich_box" v-html="htmeRich3"></div>

            </div>
          </div>
        </div>
      </el-dialog> -->
      <!--用户隐私协议end  -->

      <div style="margin-top:50px" class="formClass flex flex-row flex-algin-center flex-nowarp flex-jus-center">
        <!-- 图片上传start  v-if="active == 3" -->
        <!-- <div v-if="active == 1" class="flex flex-row flex-algin-center flex-nowarp flex-jus-between"
          style="margin-right:135px;">
          <div class="flex flex-column flex-jus-center flex-nowarp " style="margin-right: 72px;">
            <div class="flex flex-row flex-nowarp flex-jus-between">
              <p style="color:red;">*</p>缴费图片上传:
            </div>
          </div>
          <div>
            <div class="flex flex-row flex-algin-center flex-jus-start flex-nowarp" style="margin-top:24px;">
              <el-upload :action="webhost + 'usersignup/upload'" :file-list="uploadFileList"
                :before-upload="beforeUploadImg" :on-success="onUploadSuccess" :on-remove="onUploadRemove"
                :on-preview="onPreviewImg" :http-request="customUpload" list-type="picture-card"
                accept="image/jpeg,image/jpg,image/png" multiple>
                <i class="el-icon-plus"></i>
              </el-upload>
              <el-dialog :visible.sync="previewVisible" append-to-body>
                <img width="100%" :src="previewImgUrl" alt="">
              </el-dialog>
            </div>
            <div class="flex flex-row flex-algin-center flex-jus-center" style="color:rgb(168,50,38);margin-top:16px;">
              <div>
                图片要求:上传图片格式为:jpg、jpeg或png格式，可上传多张
              </div>
            </div>
          </div>
        </div> -->

        <!-- 图片上传end -->
        <!-- 审核start -->
        <div v-if="active == 3">
          <!-- <el-row :gutter="20">
            <el-col :span="12">
              <div class="grid-content bg-purple">报名类型</div>
            </el-col>
            <el-col :span="12">
              <div class="grid-content bg-purple-light">{{ form.type == 1 ? '个人' : '单位' }}</div>
            </el-col>
          </el-row> -->
          <el-row :gutter="20">
            <el-col :span="12">
              <div class="grid-content bg-purple">继续教育类别</div>
            </el-col>
            <el-col :span="12">
              <div class="grid-content bg-purple-light">{{ form.educationCategory == 4 ? '初级' : form.educationCategory == 5 ? '中级' : '高级' }}</div>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <div class="grid-content bg-purple">继续教育时间</div>
            </el-col>
            <el-col :span="12">
              <div class="grid-content bg-purple-light">{{ form.educationYear }}年</div>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <div class="grid-content bg-purple">姓名</div>
            </el-col>
            <el-col :span="12">
              <div class="grid-content bg-purple-light">{{ form.name }}</div>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <div class="grid-content bg-purple">性别</div>
            </el-col>
            <el-col :span="12">
              <div class="grid-content bg-purple-light">{{ form.sexType == 0 ? '女' : '男' }}</div>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <div class="grid-content bg-purple">民族</div>
            </el-col>
            <el-col :span="12">
              <div class="grid-content bg-purple-light">{{ form.folk || '未知' }}</div>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <div class="grid-content bg-purple">身份证号码</div>
            </el-col>
            <el-col :span="12">
              <div class="grid-content bg-purple-light">{{ form.id_card }}</div>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <div class="grid-content bg-purple">手机号</div>
            </el-col>
            <el-col :span="12">
              <div class="grid-content bg-purple-light">{{ form.mobile }}</div>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <div class="grid-content bg-purple">邮箱号码</div>
            </el-col>
            <el-col :span="12">
              <div class="grid-content bg-purple-light">{{ form.email || '未知' }}</div>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <div class="grid-content bg-purple">审核状态</div>
            </el-col>
            <el-col :span="12">
              <div v-if="passStatus" class="grid-content bg-purple-light">{{ this.form.progressName }}</div>
              <div v-else-if="noPassBecause" class="grid-content bg-purple-light">{{
                this.onlineRegistObj2.progressName
              }}
              </div>

              <div v-else class="grid-content bg-purple-light">审核中</div>
            </el-col>
          </el-row>
          <el-row v-if="noPassBecause" :gutter="20">
            <el-col :span="12">
              <div class="grid-content bg-purple">原因</div>
            </el-col>
            <el-col :span="12">
              <div class="grid-content bg-purple-light">
                {{ form.failpassReason ? onlineRegistObj2.failpassReason : '其它' }}
              </div>
            </el-col>
          </el-row>


        </div>

        <!-- 开票信息 -->
        <el-form class="inputWidthClass" v-if="active == 2" ref="invoiceForm" :model="invoiceForm" :rules="invoiceRules" label-width="200px">
          <el-form-item prop="needInvoice" label="是否开具发票:" required>
            <el-radio-group v-model="invoiceForm.needInvoice">
              <el-radio :label="false">否</el-radio>
              <el-radio :label="true">是</el-radio>
            </el-radio-group>
          </el-form-item>
          <template v-if="invoiceForm.needInvoice == true">
            <el-form-item prop="invoiceUnit" label="单位名称(个人姓名):">
              <!-- <el-input v-model="invoiceForm.invoiceUnit" placeholder="请输入单位名称(个人姓名)"></el-input> -->
              <el-autocomplete
                v-model="invoiceForm.invoiceUnit"
                :fetch-suggestions="queryInvoiceUnit"
                placeholder="请输入单位名称(个人姓名)"
                :trigger-on-focus="false"
                @select="handleSelect"
                style="width: 100%;"
              ></el-autocomplete>
            </el-form-item>
            <el-form-item prop="invoiceTaxId" label="纳税人识别号(身份证号码):">
              <el-input maxlength="30" v-model="invoiceForm.invoiceTaxId" placeholder="请输入纳税人识别号(身份证号码)"></el-input>
            </el-form-item>
            <el-form-item prop="invoiceAddress" label="地址:">
              <el-input v-model="invoiceForm.invoiceAddress" placeholder="请输入地址"></el-input>
            </el-form-item>
            <el-form-item prop="invoicePhone" label="电话:">
              <el-input maxlength="12" v-model="invoiceForm.invoicePhone" placeholder="请输入联系电话"></el-input>
            </el-form-item>
            <el-form-item prop="invoiceBank" label="开户行:">
              <el-input v-model="invoiceForm.invoiceBank" placeholder="请输入开户行"></el-input>
            </el-form-item>
            <el-form-item prop="invoiceAccount" label="账号:">
              <el-input v-model="invoiceForm.invoiceAccount" placeholder="请输入账号"></el-input>
            </el-form-item>
            <el-form-item prop="invoiceEmail" label="邮箱:" >
              <el-input v-model="invoiceForm.invoiceEmail" placeholder="请输入邮箱"></el-input>
            </el-form-item>
            <el-form-item prop="invoiceType" label="开票类型:">
              <el-select placeholder="请选择开票类型:" v-model="invoiceForm.invoiceType">
                <el-option label="增值税专用发票" :value="0"></el-option>
                <el-option label="增值税专用普票" :value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="invoiceRemark" label="备注:">
              <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" v-model="invoiceForm.invoiceRemark" placeholder="请输入发票备注"></el-input>
            </el-form-item>
          </template>
        </el-form>

        <!-- 审核end -->
        <!-- <div class="flex flex-column flex-algin-center " style="margin-top:0px"> -->
          <!-- v-if="active == 0" -->
          <!-- <div v-if="active == 0">
            <div class="welfare_publicity">
              <div class="title">报名须知</div>
              <div class="rich_box" v-html="htmeRich"></div>

            </div>
          </div> -->
          <!-- v-if="active == 0" -->
          <!-- <div v-if="active == 0">
            <div class="agreeClass flex flex-row flex-algin-center flex-jus-start flex-nowarp">
              <el-checkbox @change="agreeFun" v-model="agreement"></el-checkbox>
              <div style="color:red;text-align: center;vertical-align: middle;padding-top: 2px;margin: 0 32px;">*</div>
              <div class="agreeClassItem">
                我已阅读并接受遵守本网站
                <div @click="niema" style="color:rgb(79,148,228);display: inline-block;">《用户服务协议》</div>
                <div @click="niema2" style="color:rgb(79,148,228);display: inline-block;">《用户隐私政策》</div>
                及报名协议
              </div>
            </div>
          </div>
        </div> -->
        <el-form class="inputWidthClass" v-if="active == 0" ref="form" :model="form" :rules="rules" label-width="120px">
          <el-form-item prop="educationCategory" label="继续教育类别:">
            <el-select placeholder="请选择继续教育类别:" v-model="form.educationCategory">
              <el-option label="初级" :value="4"></el-option>
              <el-option label="中级" :value="5"></el-option>
              <el-option label="高级" :value="6"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="educationYear" label="继续教育时间:">
            <el-select placeholder="请选择继续教育年份" v-model="form.educationYear">
              <el-option v-for="year in educationYearOptions" :key="year.value" :label="year.label" :value="year.value">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 姓名 -->
          <!-- disabled -->
          <el-form-item label="姓名:" prop="name">
            <el-input v-model="form.name" placeholder="请输入姓名"></el-input>
          </el-form-item>
          <!-- 性别 -->
          <el-form-item label="性别:" prop="sexType">
            <el-select placeholder="请选择性别" v-model="form.sexType">
              <el-option label="男性" value="1"></el-option>
              <el-option label="女性" value="0"></el-option>
            </el-select>
          </el-form-item>
          <!-- 族别 -->
          <el-form-item label="族别:" prop="nationvalue">
            <nation-select :nationvalue2="form.nationvalue" @nationvalue="nationvalueChange"></nation-select>
          </el-form-item>
          <!-- 身份证、手机号码、邮箱 -->
          <el-form-item label="身份证号：" prop="id_card">
            <el-input maxlength="18" v-model="form.id_card" placeholder="请输入证件号"></el-input>
          </el-form-item>
          <el-form-item label="联系电话：" prop="mobile">
            <el-input maxlength="11" @input="form.mobile = form.mobile.replace(/^(0+)|[^\d]+/g, '')"
              v-model="form.mobile" placeholder="请输入手机号码"></el-input>
          </el-form-item>
          <el-form-item label="电子邮箱：" prop="email">
            <el-input v-model="form.email" placeholder="请输入电子邮箱（开发票必填）"></el-input>
          </el-form-item>
          <!-- end -->
        </el-form>
      </div>
      <div class="flex flex-row flex-nowarp flex-algin-center flex-jus-center" style=" ">
        <!-- active < 4 && active != 0 && active != 2 -->
        <!--  && active != 3 -->
        <el-button v-if="active != 0 && active != 4" style="margin-top: 12px;   margin-right: 30px;" @click="lastStep"
          type="danger">上一步
        </el-button>
        <!-- 表单重置按钮 -->
        <el-button type="danger" v-if="active == 0" style="margin-top: 12px" @click="resetForm('form')">重置
        </el-button>
        <el-button v-if="active == 0" type="danger" style="margin-top: 12px;margin-left:30px"
          @click="submitForm('form')">下一步
        </el-button>
        <!-- <el-button v-if="active < 1 || active == 0" style="margin-top: 12px" @click="next" type="danger">下一步
        </el-button> -->
        <!-- 图片上传下一步 -->
        <el-button v-if="active == 1" style="margin-top: 12px" @click="next2" :disabled="uploading" type="danger">下一步
        </el-button>
        <!-- 开票信息下一步 -->
        <el-button v-if="active == 2" type="danger" style="margin-top: 12px;margin-left:30px"
          @click="submitForm('invoiceForm')">下一步
        </el-button>
        <el-button type="danger" v-if="active == 2" style="margin-top: 12px" @click="resetForm('invoiceForm')">重置
        </el-button>
        <!-- 最后一步 -->
        <el-button v-if="active == 3" style="margin-top: 12px" @click="commitImgFun" type="danger">提交
        </el-button>
      </div>

    </div>
    <el-dialog
      title="职称继教缴费"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="30%"
      center>
      <div class="dialogContent">
        您选择的继续教育类别是{{ form.educationCategory == 4 ? '初级' : form.educationCategory == 5 ? '中级' : '高级' }}, 需要缴费<strong>{{ form.educationCategory == 4 ? 120 : form.educationCategory == 5 ? 160 : 200 }}</strong>元
      </div>
      <div class="payment-code">
        <!-- <img v-if="form.educationCategory == 4" class="payment-code__image" :src="payCodeJunior" alt="初级缴费码">
        <img v-if="form.educationCategory == 5" class="payment-code__image" :src="payCodeIntermediate" alt="中级缴费码">
        <img v-if="form.educationCategory == 6" class="payment-code__image" :src="payCodeAssociateSenior" alt="高级缴费码"> -->
        <img class="payment-code__image" :src="payCode" alt="缴费码">
      </div>
    </el-dialog>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "../components/Header";
import Footer from "../components/Footer";
import NationSelect from "../components/nationSelect";
// import payCodeJunior from '../../assets/payment-code-1.png';
// import payCodeIntermediate from '../../assets/payment-code-2.png';
// import payCodeAssociateSenior from '../../assets/payment-code-3.png';
import payCode from '../../assets/payment-code.png';

import { Image } from "element-ui";
export default {
  data() {
    var validateSex = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请选中性别'));
      } else {

        callback();
      }
    };
    return {
      active: 0,
      htmeRich: '',//step1
      htmeRich2: '',//服务协议
      htmeRich3: '',//隐私政策
      htmeRich4: '',//缴费通知
      agreementShow: false,
      agreementShow2: false,
      dialogVisible6: false,
      title: '',
      agreement: false,
      uploadImgUrl: [],
      uploadFileList: [], // el-upload 展示列表，用于多图回显
      previewVisible: false,
      previewImgUrl: '',
      onlineRegistObj: {},
      onlineRegistObj2: {},
      educationYearOptions: [], // 年份选项数组
      enrollDetailId: '',//报名详情id
      passStatus: false,
      noPassBecause: false,
      dialogVisible: false,// 对话框
      // payCodeJunior,
      // payCodeIntermediate,
      // payCodeAssociateSenior,
      payCode,
      uploading: false,// 图片上传状态
      form: {
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        // type: [],
        resource: "",
        desc: "",
        registType: "",
        type: '1',
        registTypeItem: '',
        sexType: "",
        nationvalue: null,
        email: "",
        mobile: "",
        id_card: "",
        folk: '',
        educationYear: '', // 继续教育时间
        educationCategory: null, // 继续教育类别
      },
      subjectCode: null,
      rules: {
        educationCategory: [
          { required: true, message: "请选择继续教育类别", trigger: "change" }
        ],
        educationYear: [
          { required: true, message: "请选择继续教育时间", trigger: "change" },
        ],
        sexType: [
          { required: true, message: "请选中性别", trigger: "change" },

        ],
        nationvalue: [
          { required: false, message: "请选中族别", trigger: "change" },
        ],
        registType: [
          { required: true, message: "请输入被报名类型", trigger: "blur" },
          {
            trigger: "blur",
          },
        ],

        registTypeItem: [
          { required: true, message: "请输入课程类型", trigger: "blur" },
          {
            trigger: "blur",
          },
        ],
        name: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          {
            min: 2,
            max: 13,
            message: "长度在 2 到 13 个字符",
            trigger: "blur",
          },
        ],
        mobile: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          // 这个只能验证手机号
          // { pattern:/^0{0,1}(13[0-9]|15[7-9]|153|156|18[7-9])[0-9]{8}$/, message: "请输入合法手机号", trigger: "blur" }
          {
            pattern: /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/,
            message: "请输入合法手机号/电话号",
            trigger: "blur",
          },
        ],
        id_card: [
          { required: true, message: "请输入身份证号", trigger: "blur" },
          {
            pattern:
              /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/,
            message: "请输入合法身份证号",
            trigger: "blur",
          },
        ],
        email: [
          { required: false, message: "请输入邮箱", trigger: "blur" },
          {
            pattern:
              /^([0-9A-Za-z\-_\.]+)@([0-9a-z]+\.[a-z]{2,3}(\.[a-z]{2})?)$/g,
            message: "请输入正确的邮箱",
            trigger: "blur",
          },
        ],
      },
      invoiceForm: {
        needInvoice: undefined,// 是否需要开具发票
        invoiceAccount: '',// 发票账号
        invoiceAddress: '',// 发票地址
        invoiceBank: '',// 开户行
        invoicePhone: '',// 联系电话
        invoiceTaxId: '',// 纳税人识别号(身份证号码) 必填
        invoiceEmail: '',// 发票邮箱
        invoiceType: undefined,// 开票类型
        invoiceUnit: '',// 单位名称(个人姓名) 必填
        invoiceRemark: '',// 备注
      },
    };
  },
  computed: {
    invoiceRules() {
      const isNeed = this.invoiceForm.needInvoice === true
      return {
        needInvoice: [
          { required: true, message: "请选择是否开具发票", trigger: "change" },
        ],
        invoiceAccount: [
          { required: false, message: "请输入发票账号", trigger: "blur" },
        ],
        invoiceAddress: [
          { required: false, message: "请输入发票地址", trigger: "blur" },
        ],
        invoiceBank: [
          { required: false, message: "请输入开户行", trigger: "blur" },
        ],
        invoicePhone: [
          { required: false, message: "请输入手机号/座机号", trigger: "blur" },
          {
            pattern: /^(?:(?:(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8})|(?:(?:\d{3})?\d{8}|(?:\d{4})?\d{7,8}))$/,
            message: "请输入合法手机号/座机号",
            trigger: "blur",
          },
        ],
        invoiceTaxId: isNeed ? [
          { required: true, message: "请输入纳税人识别号", trigger: "blur" },
          {
            pattern: /^[A-Za-z0-9]{15,30}$/,
            message: "请输入合法纳税人识别号",
            trigger: "blur",
          },
        ] : [],
        invoiceEmail: isNeed ? [
          { required: true, message: "请输入邮箱", trigger: "blur" },
          {
            pattern:
              /^([0-9A-Za-z\-_\.]+)@([0-9a-z]+\.[a-z]{2,3}(\.[a-z]{2})?)$/g,
            message: "请输入正确的邮箱",
            trigger: "blur",
          },
        ]: [],
        invoiceType: isNeed ? [
          { required: true, message: "请选择开票类型", trigger: "change" },
        ] : [],
        invoiceUnit: isNeed ? [
          { required: true, message: "请输入单位名称(个人姓名)", trigger: "blur" },
        ] : [],
        invoiceRemark: [
          { required: false, message: "请输入发票备注", trigger: "blur" },
        ]
      }
    }
  },
  components: {
    Header,
    Footer,
    NationSelect,
    Image
  },
  watch: {
    active(newVal) {
      if (newVal === 1 && this.uploadImgUrl && this.uploadImgUrl.length) {
        this.uploadFileList = this.uploadImgUrl.map(url => ({ name: url, url }));
      }
      if (newVal === 2) {
        this.invoiceForm.invoiceEmail = this.form.email
      }
    }
  },
  async mounted() {

    if (this.$route.query.subjectCode) {
      this.subjectCode = this.$route.query.subjectCode;
      this.getOnlineRegistNeedKnowFun(this.$route.query.subjectCode)
    }
    this.initEducationYearOptions()
    // 缴费图片回显：若已有图片 URL 则同步到 uploadFileList
    if (this.uploadImgUrl && this.uploadImgUrl.length) {
      this.uploadFileList = this.uploadImgUrl.map(url => ({ name: url, url }));
    }

    console.log(1111)
    // await getOnlineRegistMenuApi('02');
    // this.form.name = this.$store.state.user.realName
    // if (this.$route.query.onlineRegistObj) {

    //   this.onlineRegistObj = JSON.parse(decodeURI(this.$route.query.onlineRegistObj))

    //   // this.form.registType =  this.onlineRegistObj.categoryName
    //   // this.form.registTypeItem = this.onlineRegistObj.title
    //   console.log('233333333', typeof (this.onlineRegistObj))
    // }
    // if (this.$route.query.onlineRegistObj2) {

    //   this.onlineRegistObj2 = JSON.parse(decodeURI(this.$route.query.onlineRegistObj2))
    //   console.log(this.onlineRegistObj2)
    // }
    // console.log('alonealonealone', this.$route.query.progress)
    // if (this.$route.query.progress) {
    //   if (this.$route.query.progress == '01') {
    //     this.active = 2
    //   }//待缴费
    //   if (this.$route.query.progress == '02') {
    //     this.active = 4//审核
    //   }//已缴费
    //   if (this.$route.query.progress == '03') {
    //     this.active = 4//审核
    //     this.passStatus = true
    //   }//审核通过
    //   if (this.$route.query.progress == '04') {
    //     this.active = 4//审核
    //     this.noPassBecause = true;
    //   }//审核通过
    // }

  },
  methods: {
    //确定提交
    async commitImgFun() {
      // console.log(this.uploadImgUrl)
      // if (this.uploadImgUrl.length == 0) {
      //   this.$message('请上传图片！')
      //   return
      // }

      this.dialogVisible6 = false
      var that = this;
      this.initInvoiceForm()
      let data3 = {
        email: this.form.email,
        folk: (this.$store.state.nationList[Number(this.form.nationvalue) - 1] || {}).info || "",
        gender: this.form.sexType,
        idCard: this.form.id_card,
        realName: this.form.name,
        phone: this.form.mobile,

        paymentImg: this.uploadImgUrl.join(','),

        continueEducationTime: this.form.educationYear,
        subjectId: this.subjectCode,
        subjectCode: this.form.educationCategory,
        invoiceAccount: this.invoiceForm.invoiceAccount,// 发票账号
        invoiceAddress: this.invoiceForm.invoiceAddress,// 发票地址
        invoiceBank: this.invoiceForm.invoiceBank,// 开户行
        invoicePhone: this.invoiceForm.invoicePhone,// 联系电话
        invoiceTaxId: this.invoiceForm.invoiceTaxId,// 纳税人识别号(身份证号码) 必填
        invoiceType: this.invoiceForm.invoiceType,// 开票类型
        invoiceUnit: this.invoiceForm.invoiceUnit,// 单位名称(个人姓名) 必填
        invoiceRemark: this.invoiceForm.invoiceRemark,// 备注
      }

      console.log('data3', data3)
      var that = this;
      this.$http({
        url: that.webhost + "usersignup/save",
        method: "POST",
        data: data3
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.$message('报名成功！等待审核通过')
          this.$router.push('/')
        } else {
          this.$message(data.msg)
        }
      });
      // if (res3.code == 0) {
      //   const res2 = await isPayRegsitApi({
      //     signupId: this.onlineRegistObj.id,
      //   })
      //   if (res2.code == 0) {
      //     // this.onlineRegistObj2 = res2?.result?.list[0]

      //     console.log(this.onlineRegistObj2)

      //     this.active = 3
      //   } else {
      //     this.$message('报名成功！')
      //     this.$router.push('/onlineCourse')
      //   }

      // } else if (res3.code == 500) {
      //   this.$message(res3.msg)
      // }
    },
    // 协议相关
    async getAgreementAboutFun(idStr) {
      const res = await getAgreementAboutApi(idStr)
      console.log('resresres', res)
      // this.richAgreementText = ''
      this.htmeRich2 = res.page.records[0].content
      this.htmeRich3 = res.page.records[0].content
    },
    // 提交图片commitImgFun
    // async commitImgFun() {

    //   if (this.uploadImgUrl.length == 0) {
    //     this.$message('请上传图片！')
    //     return
    //   } else {
    //     this.dialogVisible6 = true
    //     // console.log('5555555',this.onlineRegistObj)

    //     // //
    //     //        let data3= {
    //     //       email:this.form.email,
    //     //       folk:this.$store.state.nationList[Number(this.form.nationvalue)].info,
    //     //       gender:this.form.sexType,
    //     //       idCard:this.form.id_card,
    //     //       name:this.form.name,
    //     //       phone:this.form.mobile,
    //     //       progress:'01',
    //     //       payImg:this.uploadImgUrl,
    //     //       // signupId: this.onlineRegistObj.id,
    //     //       categoryId:this.onlineRegistObj.id,
    //     //     }
    //     //       const res3 = await saveOnlineRegistStepTwoFormApi(data3);
    //     //       if(res3.code == 0){
    //     //         const res2 = await isPayRegsitApi({
    //     //                   signupId: this.onlineRegistObj.id,
    //     //               })
    //     //               if(res2.code == 0){
    //     //                 this.onlineRegistObj2 = res2?.result?.list[0]
    //     //                 this.active = 4
    //     //               }else{
    //     //                 this.$message('报名成功！')
    //     //                 this.$router.push('/home')
    //     //       }

    //     //       }

    //     // if(res3.code == 0){
    //     //     let data = {
    //     //     progress:'02',
    //     //     id: this.enrollDetailId,
    //     //     payImg:this.uploadImgUrl
    //     //     }
    //     //     const res = await updateUploadImgUrlApi(data);
    //     //     if(res.code == 0){
    //     //       this.onlineRegistObj2 = {}
    //     //       const res2 = await isPayRegsitApi({
    //     //           signupId: this.onlineRegistObj.id,
    //     //       })
    //     //       this.onlineRegistObj2 = res2.result.list[0]
    //     //       this.active = 4
    //     //     }else{
    //     //       this.$message(res.msg)
    //     //     }
    //     // }
    //     //
    //     //   let data = {
    //     //         progress:'02',
    //     //         id: this.enrollDetailId,
    //     //         payImg:this.uploadImgUrl
    //     //       }

    //     //       const res = await updateUploadImgUrlApi(data);
    //     //       if(res.code == 0){
    //     //         this.onlineRegistObj2 = {}
    //     //         const res2 = await isPayRegsitApi({
    //     //   signupId: this.onlineRegistObj.id,
    //     // })
    //     //         this.onlineRegistObj2 = res2.result.list[0]
    //     //         this.active = 4
    //     //       }else{
    //     //         this.$message(res.msg)
    //     //       }
    //   }

    // },
    // // 缴费图片上传（Element UI 多图）
    beforeUploadImg(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png';
      if (!isJPG) {
        this.$message.error('图片格式为 jpg、jpeg 或 png');
        return false;
      }
      return true;
    },
    customUpload(options) {
      this.uploading = true
      const msg = this.$message.info({
        message: '正在上传图片中',
        duration: 0,
        iconClass: 'el-icon-loading',
        customClass: 'upload-message'
      })
      const { file } = options;
      const formData = new FormData();
      formData.append('file', file, file.name);
      this.$http({
        url: this.webhost + 'usersignup/upload',
        method: 'POST',
        headers: { Accept: '*/*' },
        data: formData
      }).then((res) => {
        if (res && res.data && res.data.code === 0) {
          options.onSuccess(res.data);
          return res.data;
        } else {
          this.$message.error((res.data && res.data.msg) || '图片上传失败');
          options.onError(new Error('upload failed'));
          return Promise.reject(new Error('upload failed'));
        }
      }).catch((err) => {
        options.onError(err);
        throw err;
      }).finally(() => {
        this.uploading = false
        msg.close()
      });
    },
    onUploadSuccess(response, file, fileList) {
      console.log('response', response)
      if (response && response.url) {

        this.uploadImgUrl.push(response.url);
        console.log('uploadImgUrl', this.uploadImgUrl)
        file.url = response.url;
        file.name = file.name || response.url;
      }
    },
    onUploadRemove(file, fileList) {
      console.log('file', file)
      const url = file.url || (file.response && file.response.data && file.response.data.url);
      if (url) {
        const i = this.uploadImgUrl.indexOf(url);
        if (i > -1) this.uploadImgUrl.splice(i, 1);
      }
    },
    onPreviewImg(file) {
      this.previewImgUrl = file.url || (file.response && file.response.data && file.response.data.url);
      this.previewVisible = true;
    },
    // 提交表单
    async submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {

        if (valid) {
          if (this.active == 0) {
            this.active = 1
            this.dialogVisible = true
          } else if (this.active == 2) {
            this.form.email = this.invoiceForm.invoiceEmail
            this.active = 3
          }
        } else {
          console.log('error submit!!');
          this.$message('请填写正确完整信息方可进行下一步!')
          return false;
        }
      });
    },
    initInvoiceForm() {
      if (!this.invoiceForm.needInvoice) {
        // 不开票：清空发票相关字段
        this.invoiceForm.needInvoice = undefined
        this.invoiceForm.invoiceAccount = ''
        this.invoiceForm.invoiceAddress = ''
        this.invoiceForm.invoiceBank = ''
        this.invoiceForm.invoicePhone = ''
        this.invoiceForm.invoiceTaxId = ''
        this.invoiceForm.invoiceType = undefined
        this.invoiceForm.invoiceUnit = ''
        this.invoiceForm.invoiceRemark = ''
      }
      // 开票时不清空，保留用户已填或留空
    },
    // 用户服务协议
    niema() {
      console.log('用户协议')
      this.getAgreementAboutFun({
        "agreementType": "01",
        "page": 1,
        "size": 10
      })
      this.agreementShow = !this.agreementShow
    },
    niema2() {
      console.log('隐私协议')
      this.getAgreementAboutFun({
        "agreementType": "02",
        "page": 1,
        "size": 10
      })
      this.agreementShow2 = !this.agreementShow2
    },
    // 同意隐私
    agreeFun(e) {
      console.log('diqiushuadiao', e)
      this.agreement = e;
    },
    // 获得报名须知step1
    getOnlineRegistNeedKnowFun(code) {
      var that = this;
      this.$http({
        url: that.webhost + "guide/getBmxz",
        method: "GET",
        params: { subjectId: code }
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.htmeRich = data.data

        }
      });
    },
    // 重置数据
    resetForm(formName) {
      this.$nextTick(() => {
        this.$refs[formName].resetFields();
      })
    },
    //接收民族改变值
    nationvalueChange(data) {
      this.form.nationvalue = data.toString();
      console.log('族别', data, this.form.nationvalue)
      const nationItem = this.$store.state.nationList[Number(this.form.nationvalue) - 1];
      this.form.folk = nationItem ? nationItem.info : ""
    },
    next() {
      console.log(this.active)
      if (this.active == 0) {
        this.active = 1

        return
      } else if (this.active == 1) {
        this.$refs['form'].validate((valid) => {
          if (valid) {
            // alert('submit!');
            if (this.active++ > 2) this.active = 0

          } else {
            console.log('error submit!!');
            this.$message('请填写完整表格！')
            return false;
          }
        });
      } else if (this.active == 2) {
        this.$refs['invoiceForm'].validate((valid) => {
          if (valid) {
            if (this.active++ > 3) this.active = 0
            return
          } else {
            console.log('error submit!!');
            this.$message('请填写完整表格！')
            return false;
          }
        });
      } else if (this.active++ > 4) this.active = 0;
    },
    async next2() {
      //  const res = await isPayRegsitApi({
      //     signupId: this.onlineRegistObj.id,
      //   })
      //  if(res.code == 0){

      //   if(res.result.totalCount>0){
      //    this.enrollDetailId = res.result.list[0].id
      //     if(res.result.list[0].progress == '02'){
      //       this.active = 4
      //     }else if(res.result.list[0].progress == '01'){
      //       if (this.active++ > 4) this.active = 0;
      //     }

      //   }

      //  }


      // if (this.uploadImgUrl.length == 0) {
      //  this.$message('请上传图片！')
      //   return
      //  }
      if (this.active++ > 4) this.active = 0;
    },
    lastStep() {
      if (this.active-- < 0) this.active = 0;
    },
    initEducationYearOptions() {
      const currentYear = new Date().getFullYear();
      // const startYear = currentYear - 4;
      // 保留本年度
      const startYear = currentYear;

      for (let year = startYear; year <= currentYear; year++) {
        this.educationYearOptions.unshift({
          label: year + '年' + (year === currentYear ? '（本年度）' : '（补学）'),
          value: year.toString()
        });
      }
    },
    queryInvoiceUnit(queryString, cb) {
      var that = this;
      this.$http({
        url: that.webhost + "guide/searchCompany",
        method: "GET",
        params: { keyword: queryString }
      }).then(({ data }) => {
        if (data && data.code === 0) {
          console.log('公司搜索拿到数据', data)
          const results = data.data.items.map(item => ({
            id: item.id,
            taxId: item.creditNo,
            value: item.name
          }));
          console.log('包装结果', results)
          cb(results);
        }
      });
    },
    handleSelect(item) {
      if (item.taxId && item.value) {
        this.invoiceForm.invoiceTaxId = item.taxId;
      }
    }
  },
};
</script>

<style scoped>
.content {
  min-height: 60vh;
}

/deep/ .el-select {
  width: 100% !important;
}

.stepClass {
  margin-top: 16px;
}

.formClass {
  /* margin-top: 90px; */
}

.welfare_publicity {
  position: relative;
  width: 900px;
  margin: 0 auto;
  margin-top: 64px;
  padding: 16px;
  box-shadow: 0px 0px 10px 5px #eaeaea;
}

.welfare_publicity2 {
  position: relative;
  margin: 0 auto;
  min-height: 60vh;
  padding: 16px;
}

.welfare_publicity2 .welfare_publicity2_cancel {
  position: absolute;
  right: 20px;
  font-size: 20px;
}

.navigation {
  width: 1160px;
  margin: 0 auto;
  padding: 10px 0;
}

.rich_box {
  padding: 30px;
  margin: 0 auto;
}

.rich_box img {
  width: 100%;
}

.agreeClass {
  padding: 16px;
  background-color: rgb(239, 239, 239);
  font-size: 10px;
  margin-top: 32px;
}

.agreeClass .agreeClassItem {
  vertical-align: middle;
  text-align: center;
  padding-top: 2px;
}

.title {
  font-size: 30px;
  display: flex;
  justify-content: center;
  margin-top: 30px;
}

/* 对话框文字内容 */
.dialogContent {
  margin-bottom: 20px;
}

/* 缴费二维码大小 */
.payment-code {
  width: 300px;
  height: auto;
  /* background-color: skyblue; */
  margin: 0 auto;
}

.payment-code__image {
  width: 100%;
  height: 100%;
}

/deep/ .el-checkbox__label {
  color: black !important;
}

/deep/ .el-row {
  padding: 0px 32px;
  text-align: center;
}

/deep/ .el-col {
  width: 360px;
  border: 1px solid #ccc9c9;
  padding: 30px;
}

/deep/ .el-checkbox__input.is-checked .el-checkbox__inner,
/deep/ .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background: #0078be;
  border-color: #0078be;
}

/* .inputWidthClass /deep/ .el-form-item__label {
  width: 80px;
  text-align: center;
} */

.inputWidthClass /deep/ .el-form-item {
  width: 500px;
}

.agreement-class /deep/ .el-dialog__body {
  padding: 0px 0px;
  display: flex;
}

.agreement-class /deep/ .el-dialog__header {
  padding: 0px 0px 0px;
}

/deep/ .el-button--danger {
  background: #0078be;
  border-color: #0078be;
}
</style>



// WEBPACK FOOTER //
// src/views/onlineRegistration/index.vue